import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { format } from "date-fns";

import { TicketDetail } from "@signalist/shared-types";

import { TicketCategoryPill, TicketStatusPill } from "../../../components/TicketPills";
import { ticketLinkedEntityKey } from "../../../utils/ticketRowMeta";
import { ticketUserName } from "../utils/ticketThread";
import { TICKET_DATE_FORMAT } from "./TicketMessage";

/** The thread column's head (mockup `.thead-d`): subject + status, then the meta line. */
export const TicketDetailHeader: FunctionComponent<{ ticket: TicketDetail }> = ({ ticket }) => {
	const { t } = useTranslation();
	const linked = ticketLinkedEntityKey(ticket);

	return (
		<div className="flex flex-col gap-2 border-b border-border pb-4">
			<div className="flex items-start justify-between gap-3">
				<h2 className="text-base font-semibold text-text">{ticket.subject}</h2>
				<TicketStatusPill status={ticket.status} />
			</div>
			<div className="flex flex-wrap items-center gap-2 text-xs text-text-meta">
				<TicketCategoryPill category={ticket.category} />
				<span>·</span>
				<span>
					{t("support.detail.openedBy", {
						name: ticketUserName(ticket.createdBy),
						date: format(new Date(ticket.createdAt), TICKET_DATE_FORMAT),
					})}
				</span>
				{linked && (
					<>
						<span>·</span>
						<span>
							{t("support.detail.related", {
								entity: t(`support.linkedEntity.${linked.key}`, { id: linked.id }),
							})}
						</span>
					</>
				)}
				<span>·</span>
				<span>{t("support.detail.ticketNumber", { id: ticket.id })}</span>
			</div>
		</div>
	);
};
